"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBoardJson = void 0;
const CellJson_1 = require("./CellJson");
const isBoardJson = (value) => {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const row of value) {
        if (!Array.isArray(value)) {
            return false;
        }
        for (const cell of row) {
            if (!(0, CellJson_1.isCellJson)(cell)) {
                return false;
            }
        }
    }
    return true;
};
exports.isBoardJson = isBoardJson;
